import type { ReactNode } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@virginexperiencedays/components-v2/src/layout/Drawer';
import { IconCloseModal } from '@virginexperiencedays/components-v2/src/icons/IconCloseModal';
import { SectionHeading } from '@virginexperiencedays/components-v2/src/typography/SectionHeading';

type ReviewsDrawerProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  title: string;
  children: ReactNode;
};

export const ReviewsDrawer = ({ open, setOpen, title, children }: ReviewsDrawerProps) => {
  return (
    <Drawer
      open={open}
      onOpenChange={(isOpen) => {
        setOpen(isOpen);
      }}
      noBodyStyles
      disablePreventScroll
    >
      <DrawerContent hasHandle>
        <DrawerDescription className="sr-only">Reviews content:</DrawerDescription>
        <ReviewsDrawerHeader>{title}</ReviewsDrawerHeader>
        <DrawerBody className="pb-4 pt-0">{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

const ReviewsDrawerHeader = ({ children }) => {
  return (
    <DrawerHeader className="flex items-center">
      <DrawerTitle className="flex-1">
        <SectionHeading>{children}</SectionHeading>
      </DrawerTitle>
      <DrawerClose className="px-2">
        <IconCloseModal />
      </DrawerClose>
    </DrawerHeader>
  );
};
